import React from 'react';
import { useAuthContext } from '../../../contexts/AuthContext';
import { useLanguage } from '@contexts/LanguageContext';
import { Collection } from '@components/common';
import './DashboardPage.scss';

export const DashboardPage = () => {
    const { user } = useAuthContext();
    const { t } = useLanguage();
    const resources = [];

    // Calculate stats from resources
    const stats = {
        totalResources: resources.length,
        availableResources: resources.filter(resource => resource.is_available).length,
        categories: [...new Set(resources.map(resource => resource.category_name))].length,
        recentResources: resources.filter(resource => {
            const resourceDate = new Date(resource.created_at);
            const weekAgo = new Date();
            weekAgo.setDate(weekAgo.getDate() - 7);
            return resourceDate > weekAgo;
        }).length,
    };

    return (
        <div className="dashboard-page">
            <div className="dashboard-header">
                <h1>{t('dashboard.welcome')}, {user?.name || user?.name || 'User'}!</h1>
                <p>{t('dashboard.happeningToday')}</p>
            </div>

            <div className="dashboard-section">
                <Collection
                    modelName="resources"
                    displayType="grid"
                    title={t('dashboard.lastResources')}
                    title={t('dashboard.lastResources')}
                    // onModelClick={handleResourceClick}
                    // onModelClick={handleResourceClick}
                    className="last-resources-collection"
                    className="last-resources-collection"
                    default_order_by="-created_at"
                    enablePagination={false}
                />
            </div>
        </div>
    );
};

export default DashboardPage;